export default (annualPrice: number) => Math.ceil(annualPrice / 12);
